<template>
    <div>
        <ValidationObserver ref="formModalValidate">
               <b-col cols="12">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('name')">
                            <b-form-input type="text" v-model="formData.name"
                                          :state="errors[0] ? false : null"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>        
    </div>
</template>

<script>

    import ProgramService from '@/services/ProgramService';

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
import ConcentrationsServices from '../../../../services/ConcentrationsServices';

    export default {
        components: {
        
            ValidationObserver,
            ValidationProvider,
        
        },
        props: {
            formId: {
                type: String
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    program_code: null,
                    name: null,
                
                },
            }
        },
        async created() {
             this.get(this.formId)
        },
        methods: {
            get(id) {
                ConcentrationsServices.get(id)
                              .then(response => {
                                  let data = response.data.data;
                                  this.formData = {
                                      program_code: data.program_code,
                                      name: data.name,
                                  }

                              })
                              .catch(e => {
                                  this.showErrors(e)
                              })
            },

            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid && this.formId) {
                    this.formLoading = true;
                    ConcentrationsServices.update(this.formId, this.formData)
                                  .then(response => {
                                      this.$emit('updateFormSuccess', true)
                                      this.$toast.success(this.$t('api.' + response.data.message))
                                  })
                                  .catch(e => {
                                      this.showErrors(e, this.$refs.formModalValidate)
                                  })
                                  .finally(() => {
                                      this.formLoading = false
                                  })
                }
            }
        }
    }
</script>
